// extracted by mini-css-extract-plugin
module.exports = {"picture-radius":"picture-radius-c40da32cfa47290c5f48893f6fac2289","obs-question-message":"obs-question-message-5661764b0759ff993de72f42eb9a8c56"};